import { render, staticRenderFns } from "./CompanyUserEditRolesTab.vue?vue&type=template&id=f3dae67c"
import script from "./CompanyUserEditRolesTab.vue?vue&type=script&lang=ts"
export * from "./CompanyUserEditRolesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports